var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx, jsxs } from "react/jsx-runtime";
import {
  startTransition,
  useCallback,
  useEffect,
  useRef,
  useState
} from "react";
import { flushSync } from "react-dom";
import {
  DatePicker,
  Flex,
  Input,
  Layout,
  theme,
  Grid,
  Radio,
  Avatar
} from "antd";
import dayjs from "dayjs";
import VideosApi from "./../../api/VideosApi.js";
import SearchApi from "./../../api/SearchApi.js";
import { ReactComponent as ArrowDown } from "./../../assets/icons/arrow-down.svg";
import { ReactComponent as Calendar } from "./../../assets/icons/calendar.svg";
import { ReactComponent as Search } from "./../../assets/icons/search.svg";
import { withScrollToTop } from "./../../hoc";
import Videos from "./../../components/videosComponent/videos/Videos.js";
import { EVENT_ACTIONS, track } from "./../../lib/gtag.js";
import TabsScrollWrapper from "./../../components/tabsScrollWrapper/TabsScrollWrapper.js";
import { initialParams } from "./goalsService";
import { useTranslation } from "@inscore/shared";
const { Content } = Layout;
const { RangePicker } = DatePicker;
const { useBreakpoint } = Grid;
const Goals = ({
  leftSidebar = null,
  rightSidebar = null,
  containerClassName = ""
}) => {
  const layoutRef = useRef(null);
  const selectRef = useRef(null);
  const screens = useBreakpoint();
  const { token } = theme.useToken();
  const getVideosApi = VideosApi.getVideos();
  const searchApi = SearchApi.search();
  const { t } = useTranslation();
  const [videos, setVideos] = useState([]);
  const [leagues, setLeagues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [leagueId, setLeagueId] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      var _a;
      const isBottom = window.innerHeight + window.scrollY >= ((_a = layoutRef.current) == null ? void 0 : _a.clientHeight) - 200;
      if (isBottom && !loading && hasMore) {
        getMoreVideos();
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [hasMore, loading]);
  useEffect(() => {
    setOffset(0);
    getVideos(
      __spreadProps(__spreadValues({}, initialParams), {
        leagueId,
        startDate,
        endDate,
        searchTerm
      }),
      (data) => setVideos(data != null ? data : [])
    );
    return () => {
      getVideosApi.cancel();
    };
  }, [leagueId, startDate, endDate, searchTerm]);
  useEffect(() => {
    search({ query: "", type: 5 });
    return () => {
      searchApi.cancel();
    };
  }, []);
  const getVideos = async (params, callback) => {
    var _a;
    flushSync(() => setLoading(true));
    try {
      const response = await getVideosApi.call(params);
      callback == null ? void 0 : callback(response.data);
      setHasMore(((_a = response.data) == null ? void 0 : _a.length) === params.limit);
    } catch (error) {
      console.error("Error fetching videos:", error);
    } finally {
      startTransition(() => {
        setLoading(false);
      });
    }
  };
  const search = async (params) => {
    var _a;
    try {
      const response = await searchApi.call(params);
      setLeagues(
        ((_a = response.data) == null ? void 0 : _a.Competitions) ? [
          { id: null, name: t("all") },
          ...response.data.Competitions
        ] : []
      );
    } catch (error) {
      console.error("Error fetching videos:", error);
    }
  };
  const getMoreVideos = () => {
    const newOffset = offset + initialParams.limit;
    startTransition(() => {
      getVideos(
        __spreadProps(__spreadValues({}, initialParams), {
          leagueId,
          startDate,
          endDate,
          searchTerm,
          offset: newOffset
        }),
        (data) => {
          setVideos((prev) => [...prev, ...data != null ? data : []]);
          setOffset(newOffset);
        }
      );
    });
  };
  const handleSearchTerm = (e) => {
    startTransition(() => setSearchTerm(e.target.value));
  };
  const handleChange = (event) => {
    var _a;
    setLeagueId(event.target.value);
    (_a = selectRef.current) == null ? void 0 : _a.blur();
  };
  const handleDatesChange = (dates) => {
    const [startDate2, endDate2] = dates || [];
    setStartDate(startDate2 ? startDate2.format("YYYY-MM-DD") : null);
    setEndDate(endDate2 ? endDate2.format("YYYY-MM-DD") : null);
  };
  const disabledDate = (current) => {
    return current && current.isAfter(dayjs(), "day");
  };
  const videoClickCallback = useCallback(() => {
    track(EVENT_ACTIONS.VIDEO_FROM_GOALS);
  }, []);
  return /* @__PURE__ */ jsxs(
    Layout,
    {
      style: {
        width: "100%",
        marginBottom: 24,
        gap: 8,
        padding: !screens.lg ? "0 12px 12px 12px" : 0
      },
      className: "container",
      ref: layoutRef,
      children: [
        screens.lg && leftSidebar,
        /* @__PURE__ */ jsx(
          Content,
          {
            style: {
              padding: screens.lg ? "24px 0" : "16px 0",
              marginLeft: !leftSidebar || rightSidebar ? "auto" : 0,
              marginRight: !rightSidebar || leftSidebar ? "auto" : 0
            },
            className: "goals-content container-xs",
            children: /* @__PURE__ */ jsxs("div", { className: containerClassName, children: [
              /* @__PURE__ */ jsxs(
                Flex,
                {
                  vertical: true,
                  gap: 16,
                  style: { marginBottom: screens.lg ? 24 : 16 },
                  children: [
                    /* @__PURE__ */ jsx(TabsScrollWrapper, { children: /* @__PURE__ */ jsx(
                      Radio.Group,
                      {
                        buttonStyle: "solid",
                        value: leagueId,
                        onChange: handleChange,
                        className: "radio-group-secondary",
                        children: leagues.map((item) => /* @__PURE__ */ jsx(
                          Radio.Button,
                          {
                            value: item.id,
                            title: item.name,
                            children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 12, children: [
                              item.iconUrl && /* @__PURE__ */ jsx(
                                Avatar,
                                {
                                  size: "small",
                                  src: item.iconUrl,
                                  style: {
                                    height: 20,
                                    width: 20,
                                    flexShrink: 0,
                                    borderRadius: "50%",
                                    backgroundColor: token.colorWhite
                                  }
                                }
                              ),
                              /* @__PURE__ */ jsx("span", { className: "goals-league-name", children: item.name })
                            ] })
                          },
                          item.id
                        ))
                      }
                    ) }),
                    screens.lg && /* @__PURE__ */ jsxs(
                      Flex,
                      {
                        gap: 16,
                        align: "center",
                        style: { width: "100%" },
                        children: [
                          /* @__PURE__ */ jsx(
                            Input,
                            {
                              prefix: /* @__PURE__ */ jsx(Search, { className: "stroke-base" }),
                              style: {
                                width: "100%",
                                height: 44,
                                fontSize: token.fontSizeXS,
                                fontWeight: 700
                              },
                              onChange: handleSearchTerm,
                              onClear: () => setSearchTerm(""),
                              allowClear: true
                            }
                          ),
                          /* @__PURE__ */ jsx(
                            RangePicker,
                            {
                              prefix: /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsx(Calendar, { className: "stroke-base" }) }),
                              suffixIcon: /* @__PURE__ */ jsx(ArrowDown, { className: "stroke-base" }),
                              separator: /* @__PURE__ */ jsx("span", { children: "-" }),
                              placeholder: [
                                t("start_date"),
                                t("end_date")
                              ],
                              style: {
                                borderRadius: token.borderRadiusXS,
                                height: 44,
                                width: 320,
                                lineHeight: "44px",
                                flexShrink: 0
                              },
                              allowEmpty: [true, true],
                              disabledDate,
                              onChange: handleDatesChange
                            }
                          )
                        ]
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ jsx(
                Videos,
                {
                  wrapperClassName: "p-0",
                  videos,
                  loading,
                  videoClickCallback
                }
              )
            ] })
          }
        ),
        screens.lg && rightSidebar
      ]
    }
  );
};
var stdin_default = withScrollToTop(Goals);
export {
  stdin_default as default
};
